"use strict";
const { isLocalOrTest } = require("gather-env-config/src/envShared");
const getApiBasePath = () => {
    if (process.env.API_BASE_PATH) {
        return process.env.API_BASE_PATH.match(/^https?:\/\//)
            ? `${process.env.API_BASE_PATH}`
            : `https://${process.env.API_BASE_PATH}`;
    }
    if (process.env.REACT_APP_API_BASE_PATH) {
        return process.env.REACT_APP_API_BASE_PATH.match(/^https?:\/\//)
            ? `${process.env.REACT_APP_API_BASE_PATH}`
            : `https://${process.env.REACT_APP_API_BASE_PATH}`;
    }
    if (typeof window === "undefined")
        return "";
    if (isLocalOrTest) {
        return `http://${window.location.hostname || "localhost"}:3000`;
    }
    return window.location.origin;
};
const API_BASE_PATH = getApiBasePath();
const getSpriteServerUrl = () => {
    if (process.env.SPRITE_BASE_PATH) {
        return process.env.SPRITE_BASE_PATH.match(/^https?:\/\//)
            ? `${process.env.SPRITE_BASE_PATH}`
            : `https://${process.env.SPRITE_BASE_PATH}`;
    }
    const env = process.env.ENVIRONMENT || "prod";
    const branchName = process.env.GIT_BRANCH;
    const isBrowser = typeof window !== "undefined";
    const urls = {
        prod: "https://dynamic-assets.gather.town",
        staging: "https://dynamic-assets.staging.gather.town",
        dev: branchName
            ? `https://${branchName}-dynamic-assets.dev.k8s.gather.town`
            : "https://dynamic-assets.staging.gather.town",
        local: `http://${isBrowser ? window.location.hostname : "localhost"}:3002`,
        test: `http://${isBrowser ? window.location.hostname : "localhost"}:3002`,
    };
    return urls[env];
};
const SPRITE_BASE_PATH = getSpriteServerUrl();
module.exports = { API_BASE_PATH, SPRITE_BASE_PATH };
//# sourceMappingURL=basePaths.js.map